import { Component, HostListener, Input, ViewChild } from '@angular/core';
import { WatchAwareComponent } from '../watch-aware.component';
import { Store } from 'src/sync/store';
import { takeUntil } from 'rxjs';
import { MatMenuTrigger } from '@angular/material/menu';

@Component({
    selector: 'app-room',
    templateUrl: './room.component.html',
    styleUrls: ['./room.component.scss'],
    standalone: false
})
export class RoomComponent extends WatchAwareComponent {
    public isMobile = false;
    @Input() origin: { x: number, y: number } = { x: 0, y: 0 };
    @ViewChild('menuTrigger') public menuTrigger!: MatMenuTrigger;

    public async ngAfterViewInit() {
        Store.isMobile.pipe(takeUntil(this.destroyed)).subscribe((isMobile) => this.isMobile = isMobile);
    }
}
